module.exports = __webpack_public_path__ + "img/andong_gallery3.c5e22930.jpg";